import './TickerBand.css'
import InfiniteTicker from './InfiniteTicker'

const S = ' \u2022 '
const topText = `Bybeit, Inc. of Tokyo${S}`
const botText = `Est. 2026${S}`

export default function TickerBand() {
  return (
    <div className="ticker-band" aria-hidden="true">
      <InfiniteTicker className="ticker-row" groupClassName="ticker-copy" duration={12}>
        {topText}
      </InfiniteTicker>
      <InfiniteTicker className="ticker-row" groupClassName="ticker-copy" direction="right" duration={8}>
        {botText}
      </InfiniteTicker>
    </div>
  )
}
